(function () {
  var panel = document.querySelector('[data-ffet-panel]');
  if (panel) {
    var earlyEnd = new Date(panel.getAttribute('data-early-bird-end') + 'T23:59:00-05:00').getTime();
    var earlyPrice = parseFloat(panel.getAttribute('data-early-price'));
    var standardPrice = parseFloat(panel.getAttribute('data-standard-price'));
    var earlyVariantId = panel.getAttribute('data-early-variant-id');
    var standardVariantId = panel.getAttribute('data-standard-variant-id');

    var badge = panel.querySelector('[data-ffet-badge]');
    var deadline = panel.querySelector('[data-ffet-deadline]');
    var priceEl = panel.querySelector('[data-ffet-price]');
    var strikeEl = panel.querySelector('[data-ffet-strike]');
    var totalEl = panel.querySelector('[data-ffet-total]');
    var qtyEl = panel.querySelector('[data-ffet-qty]');
    var variantInput = panel.querySelector('[data-ffet-variant-input]');
    var qtyInput = panel.querySelector('[data-ffet-qty-input]');
    var decBtn = panel.querySelector('[data-ffet-dec]');
    var incBtn = panel.querySelector('[data-ffet-inc]');

    var qty = 2;
    var isEarly = true;
    var price = earlyPrice;

    function fmtDaysLeft(targetMs) {
      var days = Math.max(0, Math.floor((targetMs - Date.now()) / 86400000));
      return days + ' days left';
    }

    function render() {
      var now = Date.now();
      isEarly = now < earlyEnd;
      price = isEarly ? earlyPrice : standardPrice;

      if (badge) badge.textContent = isEarly ? 'Early-bird · Save $' + (standardPrice - earlyPrice) : 'General admission';
      if (deadline) deadline.textContent = isEarly ? fmtDaysLeft(earlyEnd) : 'On sale now';
      if (priceEl) priceEl.textContent = '$' + price;
      if (strikeEl) {
        if (isEarly) {
          strikeEl.textContent = '$' + standardPrice;
          strikeEl.classList.remove('is-hidden');
        } else {
          strikeEl.classList.add('is-hidden');
          strikeEl.textContent = '';
        }
      }
      if (totalEl) totalEl.textContent = '$' + (price * qty);
      if (qtyEl) qtyEl.textContent = String(qty);
      if (variantInput) variantInput.value = isEarly ? earlyVariantId : standardVariantId;
      if (qtyInput) qtyInput.value = String(qty);
    }

    if (decBtn) decBtn.addEventListener('click', function () { qty = Math.max(1, qty - 1); render(); });
    if (incBtn) incBtn.addEventListener('click', function () { qty = Math.min(20, qty + 1); render(); });

    render();
    setInterval(render, 60000);
  }

  var daySection = document.querySelector('[data-ffet-day-section]');
  if (daySection) {
    var dayBtns = daySection.querySelectorAll('[data-ffet-day-btn]');
    var dayRows = daySection.querySelectorAll('[data-ffet-day-row]');
    var hoursLabel = daySection.querySelector('[data-ffet-hours-label]');
    var satHours = daySection.getAttribute('data-sat-hours');
    var sunHours = daySection.getAttribute('data-sun-hours');

    function setDay(day) {
      dayBtns.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-ffet-day-btn') === day);
      });
      dayRows.forEach(function (row) {
        row.classList.toggle('is-hidden', row.getAttribute('data-ffet-day-row') !== day);
      });
      if (hoursLabel) hoursLabel.textContent = (day === 'sat' ? satHours : sunHours) + ' · Times subject to change';
    }

    dayBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { setDay(btn.getAttribute('data-ffet-day-btn')); });
    });

    setDay('sat');
  }
})();
